import { render, staticRenderFns } from "./InventoryConfirmModal.vue?vue&type=template&id=5aedcff0"
import script from "./InventoryConfirmModal.vue?vue&type=script&lang=js"
export * from "./InventoryConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports